import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import InputField from '../../../form/InputField';
import CheckboxField from '../../../form/CheckboxField';

const TaxTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.taxConfig')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.taxPercentage')}
                            value={settings.tax.percentage}
                            onChange={(e) => handleChange('tax', 'percentage', e.target.value)}
                            type="number"
                        />
                        <div className="space-y-4">
                            <CheckboxField
                                label={t('admin.includedInPrice')}
                                checked={settings.tax.included_in_price}
                                onChange={(e) => handleChange('tax', 'included_in_price', e.target.checked)}
                            />
                            <CheckboxField
                                label={t('admin.showTaxNumber')}
                                checked={settings.tax.show_tax_number}
                                onChange={(e) => handleChange('tax', 'show_tax_number', e.target.checked)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaxTab;
